function a(r, t) {
  return Math.floor(Math.random() * (t - r + 1) + r);
}
export {
  a as default
};
